// import React, { useState } from 'react';
// import SelectDropdown from '../../Shared/SelectDropdown';
// import { Form } from 'react-bootstrap';
// import { knowlarityApiResponseAtom } from '../../../Services/_states';
// import { useRecoilState } from 'recoil';
// import { LeadFormActions } from '../../../Services/_actions';

// export const DispositionModal = () => {
//     const [knowlarityApiResData, setKnowlarityApiResData] = useRecoilState(knowlarityApiResponseAtom);
//     const leadFormActions = LeadFormActions();
//     // const [sectedDisposition, setSectedDisposition] = useState(null);
//     return (
//         <div>
//             <SelectDropdown
//                 optionsData={leadFormActions.despositionStatusArr}
//                 selectedValue={knowlarityApiResData?.disposition ? { label: knowlarityApiResData?.disposition, value: knowlarityApiResData?.disposition } : null}
//                 placeholder="Select Disposition"
//                 handleSelect={(e) => { setKnowlarityApiResData({ ...knowlarityApiResData, disposition: e?.value || '' }) }}
//                 isClearable={true}
//             />
//             <Form.Group className='mt-3'>
//                 <Form.Control
//                     id="detail_txt_id"
//                     as="textarea"
//                     rows={3}
//                     maxLength={350}
//                     placeholder="Enter Comment Here ..."
//                     value={knowlarityApiResData?.comment || ''}
//                     onChange={(e) => setKnowlarityApiResData({ ...knowlarityApiResData, comment: e?.target?.value || '' })}
//                 // onKeyDown={(e) => {
//                 //     e?.key === 'Enter' && comment?.trim()?.length ? onSubmitComment(comment) : '';
//                 // }}
//                 />
//                 <Form.Text>Note: Max 350 characters</Form.Text>
//             </Form.Group>

//         </div>
//     );
// };

import React, { useState } from 'react';
import { TextField, Box } from '@mui/material';
import { knowlarityApiResponseAtom } from '../../../Services/_states';
import { useRecoilState } from 'recoil';
import { LeadFormActions } from '../../../Services/_actions';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

export const DispositionModal = () => {
    const [knowlarityApiResData, setKnowlarityApiResData] = useRecoilState(knowlarityApiResponseAtom);
    const leadFormActions = LeadFormActions();

    const handleSelectDisposition = (selectedValue: any) => {
        setKnowlarityApiResData({
            ...knowlarityApiResData,
            disposition: selectedValue ? selectedValue.value : ''
        });
    };

    return (
        <Box>
            <SearchableDropdown
                options={leadFormActions.despositionStatusArr}
                value={knowlarityApiResData?.disposition ? { label: knowlarityApiResData?.disposition, value: knowlarityApiResData?.disposition } : null}
                onChange={handleSelectDisposition}
                label="Disposition"
                isClearable={true}
                required
            />

            <Box mt={3}>
                <TextField
                    id="detail_txt_id"
                    label="Enter Comment Here ..."
                    multiline
                    rows={3}
                    variant="outlined"
                    fullWidth
                    value={knowlarityApiResData?.comment || ''}
                    onChange={(e) => setKnowlarityApiResData({ ...knowlarityApiResData, comment: e?.target?.value || '' })}
                    inputProps={{ maxLength: 350 }}
                    helperText={`${knowlarityApiResData?.comment?.length || 0}/350 characters`}
                />
            </Box>
        </Box>
    );
};
